import { render, staticRenderFns } from "./NotificationItemsDropdown.vue?vue&type=template&id=4c79f428&scoped=true&"
import script from "./NotificationItemsDropdown.vue?vue&type=script&lang=js&"
export * from "./NotificationItemsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NotificationItemsDropdown.vue?vue&type=style&index=0&id=4c79f428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c79f428",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCol,VContainer,VIcon,VListItem,VRow,VTooltip})
